import { defaultLang } from './i18n/i18n';
import { normalizeLanguage } from './i18n/useLanguage';

export function googlePlayUrl(language) {
  const url = new URL('https://play.google.com/store/apps/details');
  url.searchParams.set('id', 'app.plannely');
  url.searchParams.set('hl', normalizeLanguage(language) || defaultLang);
  return url.toString();
}
